import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Story from "@/pages/Story";
import Farm from "@/pages/Farm";
import Stay from "@/pages/Stay";
import Dining from "@/pages/Dining";
import Experiences from "@/pages/Experiences";
import Contact from "@/pages/Contact";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/story" element={<Story />} />
          <Route path="/farm" element={<Farm />} />
          <Route path="/stay" element={<Stay />} />
          <Route path="/dining" element={<Dining />} />
          <Route path="/experiences" element={<Experiences />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
